import { render, staticRenderFns } from "./CostPivotSlider.vue?vue&type=template&id=3b4e0f55"
import script from "./CostPivotSlider.vue?vue&type=script&lang=js"
export * from "./CostPivotSlider.vue?vue&type=script&lang=js"
import style0 from "./CostPivotSlider.vue?vue&type=style&index=0&id=3b4e0f55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports